module.exports = "export default __webpack_public_path__ + &quot;02c0b32e0a063a170768159ed6e09b34.svg&quot;;"